import { render, staticRenderFns } from "./Invitation.vue?vue&type=template&id=baaecfd0&scoped=true"
import script from "./Invitation.vue?vue&type=script&lang=js"
export * from "./Invitation.vue?vue&type=script&lang=js"
import style0 from "./Invitation.vue?vue&type=style&index=0&id=baaecfd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baaecfd0",
  null
  
)

export default component.exports